@use "../../styles/responsive";

$component-name: "accordion";

@keyframes accordion-slide-down {
  from {
    height: 0;
  }
  to {
    height: var(--radix-accordion-content-height);
  }
}

@keyframes accordion-slide-up {
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }
}

.accordion {
  --ixf-accordion-border: 1px solid var(--ixf-color-separator);
  --ixf-accordion-header-background: var(--ixf-color-neutral-xlt);
  --ixf-accordion-duration: 150ms;
  --ixf-accordion-label-font-size: 0.875rem;
  --ixf-accordion-label-line-height: 1.5rem;
  --ixf-accordion-icon-size: 16px;

  display: flex;
  flex-direction: column;

  @include responsive.responsive-props($component-name, "gap", "gap");
}

.item {
  position: relative;
  min-width: 0;
  background: var(--ixf-color-background);
  border-radius: var(--ixf-border-radius-2);
  overflow: hidden;

  &::after {
    position: absolute;
    z-index: 1;
    inset: 0;
    border-radius: inherit;
    box-shadow: 0 0 0 1px var(--ixf-color-separator) inset;
    pointer-events: none;
    content: "";
  }

  &:has(.trigger:focus-visible)::after {
    box-shadow: 0 0 0 2px var(--ixf-text-tone-md) inset;
  }
}

.header {
  margin: 0;
  font: inherit;
  color: inherit;
}

.trigger {
  display: flex;
  align-items: center;
  gap: var(--ixf-space-2);
  width: 100%;
  padding: var(--ixf-space-2) var(--ixf-space-3) var(--ixf-space-2)
    var(--ixf-space-4);
  background: var(--ixf-accordion-header-background);
  border: none;
  border-bottom: var(--ixf-accordion-border);
  font: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;

  &[data-state="closed"] {
    border-bottom-color: transparent;

    &:hover,
    &:active {
      color: var(--ixf-color-neutral-dk);
    }
  }

  &:hover,
  &:active {
    color: var(--ixf-color-neutral-dk);
  }

  &:focus-visible {
    outline: none;
    box-shadow: none;
  }

  &[data-disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.icon {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;

  svg {
    height: var(--ixf-accordion-icon-size);
    width: var(--ixf-accordion-icon-size);
  }
}

.label {
  flex: 1 1 auto;
  min-width: 0;
  text-align: left;
  font-size: var(--ixf-accordion-label-font-size);
  line-height: var(--ixf-accordion-label-line-height);
}

.chevron {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;

  @media (prefers-reduced-motion: no-preference) {
    transition: transform var(--ixf-accordion-duration) ease-out;
  }
}

.trigger[data-state="open"] .chevron {
  transform: rotate(90deg);
}

.content {
  overflow: hidden;

  &[data-state="open"] {
    @media (prefers-reduced-motion: no-preference) {
      animation: accordion-slide-down var(--ixf-accordion-duration) ease-out;
    }
  }

  &[data-state="closed"] {
    @media (prefers-reduced-motion: no-preference) {
      animation: accordion-slide-up var(--ixf-accordion-duration) ease-out;
    }

    @media (prefers-reduced-motion: reduce) {
      height: 0;
    }
  }
}
